
import { withAxios } from 'op/components/auth';
import Remarks from 'op/components/remarks';
import React from 'react';
import { hot } from 'react-hot-loader';
import { compose } from 'recompose';
import { Card, Icon, Image } from 'semantic-ui-react';
import styled from 'styled-components';
import StpBlack from '../../../assets/stp-black.svg';
import CardWrapper from './card-wrapper';
import { withItemSelection } from './info-card.helper';

const ItemDisplay = ({ item, axios }) => {
	return (
		<CardWrapper>
			<Card className='item-info'>
				<Card.Content>
					<Card.Header>
						{item.ASM_Item_Name} / {item.ASM_Item_ID}
					</Card.Header>
					<Card.Description>
						<strong>Serial number:</strong> {item.ASM_Item_Serial} <br />
						<strong>Model:</strong> {item.ASM_Item_Model} <br />
						<strong>Location:</strong> {item.ASM_Item_Location}
					</Card.Description>
				</Card.Content>
			</Card>
		</CardWrapper>
	)
};

export default compose(
	withItemSelection,
	hot(module),
	withAxios
)(ItemDisplay);
